"use client";
import React, { useContext, useState, useMemo } from "react";

const PubnubContext = React.createContext({});

export const PubnubProvider = ({ children }) => {
  const [data, setData] = useState({});
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const { uid, channel } = data;
  const providerValue = useMemo(
    () => ({
      uid,
      channel,
      setData,
      isLoggingOut,
      setIsLoggingOut,
    }),
    [uid, channel, setData, isLoggingOut, setIsLoggingOut]
  );

  return <PubnubContext.Provider value={providerValue}>{children}</PubnubContext.Provider>;
};

export const usePubnubData = () => useContext(PubnubContext);

export const withPubnub = (Component) => (props) => <Component {...props} {...usePubnubData()} />;
